// extracted by mini-css-extract-plugin
export default {"child":"Auth-module__child--_lZ6f","title":"Auth-module__title--WCquN"};